<template>
  <div class="loading-cont">
    <!-- <van-overlay show>

    </van-overlay> -->
    <div class="loading-bg">
      <img src="../../assets/loading.gif" class="loading"/>
    </div>
  </div>
</template>

<script>
  import $request from "@/service.js";
  import {
    Overlay,
    Loading
  } from 'vant';
  export default {
    name: '',
    components: {
      [Overlay.name]: Overlay,
      [Loading.name]: Loading
    },
    data() {
      return {

      }
    },
    mounted() {
      console.log('jjjj')
    },
    methods: {

    }
  }
</script>

<style lang="less" scoped>
  .loading-bg {
    width: 90px;
    height: 75px;
    border-radius: 8px;
    position: fixed;
    top: 50%;
    margin-top: -45px;
    left: 50%;
    margin-left: -45px;
    z-index: 999;
    background-color: rgba(0,0,0,0.4);
    text-align: center;
    padding-top: 15px;
  }
  .loading{
    width: 60px;
    height: 60px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/loading.vue